import(/* webpackMode: "eager", webpackExports: ["ShopLabsPage"] */ "/app/src/features/shop/features/labs/pages/ShopLabsPage.tsx");
